import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapProjectsSettingsTerritories = {
  index: async(props) => {
    const { default: TerritoriesSettings } = await import('@/vue_widgets/mlap/settings/territories/index.vue')
    createVueApp(TerritoriesSettings, { props })
  }
}
